<template>
	<div>
		<div class="flex justify-between items-center">
			<div class="lg:hidden font-bold">Artikelnummer:</div>
			<div>{{ article.webcode }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{ 
	article: any;
}>()
</script>
